import type { FallbackRender } from "@sentry/react"
import { showReportDialog } from "@sentry/react"
import { useT } from "@holigral/shared/i18n"

type Props = Parameters<FallbackRender>[0]

// Plain Tailwind fallback — replace with the design system when it lands.
export default function ErrorDisplay({ eventId }: Props) {
  const { t } = useT("shared")

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <div className="flex max-w-sm flex-col items-center gap-6 px-6 text-center">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-normal tracking-tight">
            {t("error.title")}
          </h1>
          <p className="text-sm text-muted-foreground">{t("error.body")}</p>
        </div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="rounded-md border border-khepri-text px-3 py-2 font-sans text-sm text-khepri-text hover:bg-khepri-tint"
            onClick={() => {
              showReportDialog({ eventId })
            }}
          >
            {t("error.report")}
          </button>
          <span className="text-xs text-muted-foreground">{t("or")}</span>
          <a
            href="/"
            className="rounded-md border border-khepri-text px-3 py-2 font-sans text-sm text-khepri-text hover:bg-khepri-tint"
          >
            {t("error.home")}
          </a>
        </div>
      </div>
    </div>
  )
}
